<template>
  <v-dialog :value="active" :lazy="true" persistent max-width="800px">
    <v-card >
      <v-form ref="editForm" @submit.prevent="mode === 'edit' ? update() : add()">
        <v-toolbar card color="primary" dark>
          <v-spacer></v-spacer>
          <v-toolbar-title v-if="mode === 'edit'">{{$t('demandProfiles.updateTitle')}}</v-toolbar-title>
          <v-toolbar-title v-else>{{$t('demandProfiles.addTitle')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text v-if="mode === 'edit' && currentModel == null" class="text-xs-center">
          <v-progress-circular
            :width="6"
            :size="60"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
          <v-container grid-list-md>
            <v-layout wrap >
              <v-flex xs12>
                <v-text-field
                  :label="$t('demandProfiles.name')"
                  v-model="currentModel.name"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                  :items="$store.getters['demandProfiles/type']"
                  item-text="name"
                  item-value="number"
                  v-model="currentModel.type"
                  :label="$t('demandProfiles.type')"
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  type="number"
                  :label="$t('demandProfiles.variability')"
                  v-model.number="currentModel.variability"
                  :rules="[v => v >= 0 || $t('fields.required')]"
                  :hint="$t('demandProfiles.variabilityHint')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="currentModel.type === 1">
                <v-card>
                  <v-toolbar card color="primary" dark dense v-if="currentModel.demands && currentModel.demands.length > 0">
                    <v-spacer></v-spacer>
                    <v-toolbar-title >{{$t('demandProfiles.customDemandsTitle')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-data-table
                    v-if="currentModel.demands && currentModel.demands.length > 0"
                    :headers="$store.getters['demandProfiles/demandsHeaders']"
                    :items="currentModel.demands"
                    item-key="week"
                    class="demands-datatable"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-center">{{ props.item.week }}</td>
                      <td class="text-xs-right">
                        <v-edit-dialog
                          :return-value.sync="props.item.demands"
                          large
                          lazy
                          :cancel-text="$t('general.close')"
                          :save-text="$t('general.update')"
                          class="text-xs-center"
                          @close="checkForEmptyValue"
                        >
                          {{ props.item.demands }}
                          <template v-slot:input>
                            <v-text-field
                              type="number"
                              v-model.number="props.item.demands"
                              label="Edit"
                              single-line
                              autofocus
                              :rules="[v => !!v || $t('fields.required')]"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex xs12 v-if="currentModel.type === 1" class="text-xs-center">
                <v-btn
                  color="primary"
                  @click.native="$refs.demandsInput.click()"
                  :loading="$store.state.demandProfiles.loading"
                >{{$t('demandProfiles.importDemandsButton')}}</v-btn>
                <input
                  ref="demandsInput"
                  name="fileUpload"
                  type="file"
                  accept=".xlsx"
                  @change="readExcelFile($event)"
                  style="display:none"
                >
                <v-btn
                  color="secondary"
                  :href="templateExcelUrl"
                  target="_blank"
                >{{$t('demandProfiles.importDemandsTemplateButton')}}</v-btn>
              </v-flex>
              <v-flex xs6 v-if="currentModel.type === 2">
                <v-text-field
                  type="number"
                  :label="$t('demandProfiles.min')"
                  v-model.number="currentModel.min"
                  :rules="[v => v >= 0 || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="currentModel.type === 2">
                <v-text-field
                  type="number"
                  :label="$t('demandProfiles.max')"
                  v-model.number="currentModel.max"
                  :rules="[v => v >= 0 || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="currentModel.type === 3">
                <v-text-field
                  type="number"
                  :label="$t('demandProfiles.constant')"
                  v-model.number="currentModel.constant"
                  :rules="[v => v >= 0 || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="mode === 'edit'"
            color="primary"
            :loading="$store.state.demandProfiles.loading"
            submit
            flat
            type="submit"
          >{{$t('general.update')}}</v-btn>
          <v-btn
            v-else
            color="primary"
            :loading="$store.state.demandProfiles.loading"
            type="submit"
            flat
          >{{$t('general.add')}}</v-btn>
          <v-btn
            color="secondary"
            :disabled="$store.state.demandProfiles.loading"
            submit
            flat
            @click.native="$emit('closedialog')"
          >{{$t('general.close')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import readXlsxFile from 'read-excel-file'
import Config from '@/config'
export default {
  name: "UpdateDemandProfile",
  props: { active: Boolean, id: {}, mode: String },
  data() {
    return {
      schema: {
        'week': {
          prop: 'week',
          type: Number
        },
        'demands': {
          prop: 'demands',
          type: Number,
          required: true
        }
      },
      rules: {
        required: value => !!value || this.$t('fields.required')
      },
      currentModel: {},
      templateExcelUrl: Config.filesUrl + 'templates/Import-demandes-template.xlsx'
    };
  },
  methods: {
    async init() {
      await this.$nextTick()
      this.$refs.editForm.reset();
      if (this.mode === 'edit') {
        this.getModel()
      } else {
        this.currentModel = Object.assign({}, this.$store.state.demandProfiles.model)
      }
    },
    async add() {
      if (this.$refs.editForm.validate()) {
        if (await this.$store.dispatch("demandProfiles/add", this.currentModel)){
          this.$emit('closedialog')
        }
      }
    },
    async update() {
      if (this.$refs.editForm.validate()) {
        if (
          await this.$store.dispatch("demandProfiles/update", {
            id: this.id,
            data: this.currentModel
          })
        ) {
          this.$emit("closedialog");
        }
      }
    },
    async getModel() {
      this.currentModel = null
      let model = await this.$store.dispatch("demandProfiles/getOne", this.id);
      this.currentModel = Object.assign({}, model);
    },
    async readExcelFile(e) {
      readXlsxFile(e.target.files[0], { schema: this.schema }).then(({ rows }) => {
        this.currentModel.demands = rows
        this.$refs["demandsInput"].value = "";
      })
    },
    async checkForEmptyValue() {
      this.currentModel.demands.forEach(demand => {
        if (!demand.demands || demand.demands < 0) {
          demand.demands = 0
        }
      });
    }
  },
  computed: {
    ...mapGetters('user', {
      user: 'current'
    })
  },
  watch: {
    active(val) {
      if (val) {
        this.init()
      }
    }
  }
};
</script>
<style>
.text-xs-center .v-menu__activator {
    justify-content: center
}
.demands-datatable{
  max-height: 400px !important;
  overflow-y: auto !important;
}
</style>

